import { render } from "./ChatMessageDate.vue?vue&type=template&id=a9a78596&scoped=true"
import script from "./ChatMessageDate.vue?vue&type=script&lang=js"
export * from "./ChatMessageDate.vue?vue&type=script&lang=js"

import "./ChatMessageDate.vue?vue&type=style&index=0&id=a9a78596&lang=scss&scoped=true"

import exportComponent from "/var/www/vimashenets/data/www/valera.report.tz365.ru/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9a78596"]])

export default __exports__